import * as fromReservation from './reservation.reducer';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export const reducers = fromReservation.reducer;

export const selectReservationState = createFeatureSelector<fromReservation.State>('reservation');

export const getReservationStatus = createSelector(selectReservationState, fromReservation.getReservationStatus);
